module.exports = __webpack_public_path__ + "static/media/ronin.838ef043.svg";